module.exports = __webpack_public_path__ + "fonts/Libre_Franklin-700-vietnamese13.0925fd7.woff2";